// 解密

function decrypt_token(value) {
	if (value.length > 30) {
		var len = value.length
		var token_new1 = value.substring(0, 12)
		var token_new2 = value.substring(14, 20)
		var token_new3 = value.substring(23, 27)
		var token_new4 = value.substring(30, len + 1)
		var old_token = token_new1 + token_new2 + token_new3 + token_new4
		return old_token
	} else {
		return
	}


}

// 加密

function encryption_token(value) {
	var len = value.length
	var token1 = value.substring(0, 12)
	var token_str1 = randomStr(true,4,4)
	var token2 = value.substring(12, 18)
	var token_str2 = randomStr(true,3,3)
	var token3 = value.substring(18, 22)
	var token_str3 = randomStr(true,3,3)
	var token4 = value.substring(22, len + 1)
	var token_new = token1 + token_str1 + token2 + token_str2 + token3 + token_str3 + token4
	return token_new
}


//生成随机字符串

/**
 * @param 
 * @arrange （www.idcnote.com）
 * param flag 是否是任意长度
 * param min 任意长度最小值
 * param max 任意长度最大值
 */
function randomStr(flag, min, max) {
	var str = "";
	var index = "";
	var range = min;
	var arr = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b',
		'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p',
		'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'A', 'B', 'C', 'D',
		'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R',
		'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'
	];
	//min,max范围内随机的一个数
	if (flag) {
		range = Math.floor(Math.random() * (max - min + 1) + min);
	}
	for (var i = 0; i < range; i++) {
		index = Math.round(Math.random() * (arr.length - 1));
		str += arr[index];
	}
	return str;
}


// 用户信息解密

function decryption_info(value){
	var len = value.length
	var info1 = value.substring(len-5, len+1)
	var info2 = value.substring(len-12, len-5)
	var info3 = value.substring(len-25, len-12)
	var info4 = value.substring(0, len-25)
	var info=info1+info2+info3+info4
	var val_info=decrypt_token(info)
	return val_info
}



export {
	decrypt_token,
	encryption_token,
	decryption_info
}
